import React from 'react';
import PropTypes from 'prop-types';

function ChatHeader(props) {
  return <div className="chat-area-header" />;
}

ChatHeader.propTypes = {};

export default ChatHeader;
